// Категорії та логіка відображення чекбоксів
import React from 'react';
import {
  FC_KHARKIV,
  getCanonicalTeamName,
  normalizeTeamSections,
} from '../config/teamAliases';

const sectionsByCategory = {
  'Футбол України': [
    'Кубок України',
    'Збірна України',
    'УПЛ',
    'Шахтар',
    'ЛНЗ',
    'Полісся',
    'Динамо Київ',
    FC_KHARKIV.name,
    'Колос',
    'Кривбас',
    'Зоря',
    'Карпати',
    'Епіцентр',
    'Верес',
    'Оболонь',
    'Кудрівка',
    'Буковина',
    'Чорноморець',
    'Лівий Берег',

    'Перша Ліга',
    'Олександрія',
    'Полтава',
    'Агробізнес',
    'Інгулець',
    'Прикарпаття',
    'Металіст',
    'Пробій',
    'Фенікс-Маріуполь',
    'Вікторія',
    'ЮКСА',
    'Нива',
    'Чернігів',
    'Куликів-Білка',
    'Локомотив',

    'Друга Ліга',
    'Рух',
    'Поділля',
    'Металург',
    'Діназ',
    'Скала 1911',
    'Нива Вінниця',
    'Атлет',
    'Вільхівці',
    'Ребел',
    'Тростянець',
    'Пенуел',
    'Брацлав',
    'Дністер',
    'Авангард',
    'Карбон',
  ],

  'Чемпіонати': [
    'Європейські новини',
    'Світовий футбол',
    'Англійська Премʼєр-ліга',
    'Іспанська Ла Ліга',
    'Німецька Бундесліга',
    'Французька Ліга 1',
    'Італійська Серія А',
  ],

  'Єврокубки': [
    'Ліга Чемпіонів',
    'Ліга Європи',
    'Ліга Конференцій',
  ],

  'Біатлон': [
    'Новини',
    'Кубок Світу',
    'Кубок IBU',
    'Чемпіонат Світу',
  ],

  'Види спорту': [
    'Бокс',
    'Теніс',
    'MMA',
    'Футзал',
  ],

  'Турніри': [
    'Клубний чемпіонат світу 2025',
    'Чемпіонат світу 2026',
    'Чемпіонат Європи з футзалу 2026',
  ],
};

const SectionSelector = ({
  category,
  selectedSections,
  setSelectedSections,
}) => {
  const normalizedSelectedSections = normalizeTeamSections(selectedSections);

  const handleToggleSection = (section) => {
    setSelectedSections((prev) =>
      normalizeTeamSections(prev).includes(section)
        ? normalizeTeamSections(prev).filter((s) => s !== section)
        : [...normalizeTeamSections(prev), getCanonicalTeamName(section)]
    );
  };

  if (!category || !sectionsByCategory[category]) {
    return <p>Оберіть категорію</p>;
  }

  return (
    <>
      {sectionsByCategory[category].map((section) => (
        <label
          key={section}
          style={{
            display: 'block',
            marginBottom: '5px',
          }}
        >
          <input
            type="checkbox"
            value={section}
            checked={normalizedSelectedSections.includes(section)}
            onChange={() => handleToggleSection(section)}
          />

          {section}
        </label>
      ))}
    </>
  );
};

export { sectionsByCategory };
export default SectionSelector;
